import React from "react";
import { GlossaryWrapper } from "./GlossaryWrapper";
import { GLOSSARY_DATA_PART_ONE } from "./glossaryData";

export function ReportGlossaryPartOne() {
  return <GlossaryWrapper data={GLOSSARY_DATA_PART_ONE} iconFolder="Social" />;
}
